import { NgIf } from '@angular/common';
import { Component, computed, EventEmitter, input, Input, Output } from '@angular/core';
import {
  DxTextBoxModule,
  DxValidatorModule
} from 'devextreme-angular';
import { DxiButtonModule } from 'devextreme-angular/ui/nested';
import { FormValidationComponent } from '../form-validation/form-validation.component';

@Component({
    selector: 'form-textbox',
    templateUrl: './form-textbox.component.html',
    styleUrls: ['form-textbox.component.scss'],
    imports: [DxTextBoxModule, DxValidatorModule, NgIf, DxiButtonModule]
})
export class FormTextboxComponent extends FormValidationComponent {
  @Input() isEditing = false;
  @Input() label = '';
  @Input() mask: string = null;
  @Input() icon: string = null;
  @Input() value!: string;

  @Output() valueChange = new EventEmitter<string>();

  isEmail = input(false);

  textboxValidationRules = computed(() => {
    const rules = this.validationRules();
    if (this.isEmail()) rules.push({ type: 'email' });
    return rules;
  });

  valueChanged(e) {
    this.valueChange.emit(e.value);
  }
}


